import React from "react";
import { FaBoxOpen, FaForward } from "react-icons/fa";

// inc_sites.material_mode — whether the site went ahead with planned material
// or through "Continue without material". Null until one of the two happens.
export type IncMaterialMode = "with_material" | "without_material" | null | undefined;

export const MATERIAL_MODE_OPTIONS = [
  { value: "with_material", label: "With material" },
  { value: "without_material", label: "Without material" },
];

export const materialModeLabel = (mode: IncMaterialMode) =>
  mode === "without_material" ? "Without material" : mode === "with_material" ? "With material" : "Not decided";

const MaterialModeBadge: React.FC<{ mode: IncMaterialMode; showUndecided?: boolean; title?: string }> = ({
  mode,
  showUndecided = false,
  title,
}) => {
  if (!mode) {
    return showUndecided ? (
      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-500" title={title}>
        Material: not decided
      </span>
    ) : null;
  }
  const without = mode === "without_material";
  const Icon = without ? FaForward : FaBoxOpen;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
        without ? "bg-orange-100 text-orange-800" : "bg-teal-100 text-teal-800"
      }`}
      title={title}
    >
      <Icon className="w-2.5 h-2.5" />
      {materialModeLabel(mode)}
    </span>
  );
};

export default MaterialModeBadge;
